<template>
  <div>
    <Table :columns="columns1" :data="list.body"></Table>
    <div  class="page-box">
        <Page :total="list.page.count" :page-size="page_size" :page-num="page_num" @on-change="change_page" v-if="list.page"/>
    </div>


    <!-- 申请二次确认 -->
    <Modal
        :scrollable="true"
        v-model="confirmModal"
        title="是否确认"
        @on-ok="join">
        <p style="color:red;">是否确认申请加入该队伍</p>
    </Modal>
  </div>
</template>
<script>
    import {mapState,mapActions} from 'vuex'
    export default {
        data(){
            return {
                confirmModal:false,
                current_info:{},
                compet_id:0,
                page_size:30,
                page_num:0,
                columns1: [
                        {
                            title:"名称",
                            key:"name",
                        },
                        {
                            title:"人数",
                            key:"curr_nop"
                        },
                        {
                            title:"操作",
                            key:"edit",
                            render:(h,params)=>{
                                // if( this.myTeam.body.id  > 0 ){
                                //     return h('div',{},"-")
                                // }else{
                                    return h('div',[h('Button',{props:{
                                        type:'primary',
                                        size:"small"
                                    },on:{
                                        click:()=>{
                                            this.current_info = params.row;
                                            this.confirmModal = true;
                                            // this.join(params.row);
                                        }
                                    }},"加入")])
                                // }  
                            }
                        }
                ],
            }
        },
        computed:{
            ...mapState({
                list:state=>state.team.teamall_list,
                myTeam:state=>state.team.myteam_list
            })
        },
        methods:{
            ...mapActions({
                getTeamAll:'team/getTeamAll',
                applyJoinTeam:'team/applyJoinTeam'
            }),
            getList(){
                let _this = this;
                _this.getTeamAll({
                    data:{
                        compet_id:_this.compet_id
                    }
                });
            },
            change_page(page){
                this.page_num = page;
                this.getList();
            },
            join(){
                let _this = this;
                _this.applyJoinTeam({
                    data:{
                        team_id:_this.current_info.id
                    },
                    callback:res=>{
                        _this.$Message.success("申请成功");
                    },
                    error:msg=>{
                        _this.$Message.error(msg);
                    }
                })
            }
        },
        mounted(){
            let _this = this;
            _this.compet_id = this.$route.params.id;
            if(_this.compet_id > 0){
                this.getList();
            }
        }
    }
</script>
<style>
    .block-header{
        align-items: center;
        display: flex;
        min-height: 56px;
    }
    .block-wrapper{
        margin-bottom: 24px;
        width:100%;
    }
    .team-item {
        background-color: #f1f4f9;
    }
    .list-item{
        display: -ms-flexbox;
        display: flex;
        -ms-flex-align: center;
        align-items: center;
        -ms-flex-pack: justify;
        justify-content: space-between;
        padding: 16px;
    }
    .list-item .list-item-ctr {
        display: -ms-flexbox;
        display: flex;
        -ms-flex-align: center;
        align-items: center;
    }
    .list-item img {
        margin-right: 16px;
        width: 48px;
        height: 48px;
    }
    .list-item .list-item-info h3 {
        font-weight: 700;
        margin-bottom: 8px;
    }
    .list-item .list-item-info h3 .text-fade {
        font-weight: 400;
        margin-left: 12px;
    }
    .text-fade {
        color: #9b9b9b;
    }
    .list-item .list-item-info p {
        font-size: 12px;
    }
    .text-fade {
        color: #9b9b9b;
    }
    .member-item {
        border-bottom: 1px solid #e8eaec;
        padding-left: 48px;
    }
    .member-item img {
        border-radius: 50%;
    }
</style>